(function ($, root, undefined) {

    'use strict';

    function getNextPosts() {
        jQuery.ajax({
            // we get my_plugin.ajax_url from php, ajax_url was the key the url the value
            url : newsdata.url,
            type : 'post',
            data : {
                // remember_setting should match the last part of the hook (2) in the php file (4)
                action : 'post_load',
                nce  : newsdata.nce,
                term : newsdata.term,
                offset : newsdata.offset,
                home : newsdata.home,
                taxonomy : newsdata.taxonomy,
            },
            // if successfully show the result in the console
            // you could append the outcome in the html of the
            // page
            beforeSend : function() {
                $('div.load-more').hide();
            },
            success : function( response ) {
                if (response.result === 'success') {
                    newsdata.offset += 8;
                    $( "div.load-more" ).before(response.posts);
                    $('div.load-more').show();
                } else if (response.result === 'partly') {
                    newsdata.offset += 8;
                    $("div.load-more" ).before(response.posts);
                    $('div.load-more').show();
                }

            }
        });

    }

    function displayInactiveArticles() {
        $('.article-inactive').addClass('article-active').removeClass('article-inactive');
        getNextPosts();
    }

    /*
     *      DOCUMENT READY
     */

    jQuery(document).ready(function () {
        $('div.load-more').on('click', displayInactiveArticles);
    })

})(jQuery, this);
